import {connect} from "react-redux";
import {Renderer} from "../../fstn/renderer";
import React, {useEffect, useRef, useState} from "react";
import Dialog from "../dialogs/Dialog";
import {Box, Typography} from "@mui/material";

interface Props {
    renderer: Renderer
}
function Game({renderer}: Props) {
    const gameRef = useRef<HTMLDivElement>(null);
    const [firstInteraction, setFirstInteraction] = useState(true);
    const handleCloseDialog = () => {
        setFirstInteraction(false);
    }

    useEffect(() => {
        if (gameRef.current) {
            if (firstInteraction) {
                renderer.attach(gameRef.current);
            } else {
                renderer.play();
            }
        }
    }, [firstInteraction, gameRef, renderer]);

    return (
        <>
            <Box flexGrow={1} margin="5%">
                <div ref={gameRef} style={{height: "100%", width: "100%"}}/>
                {firstInteraction && <Dialog onClose={handleCloseDialog}>
                    <Box m={1} p={1}>
                        <Typography>
                            This dialog ensures that you have interacted with the screen so that we can play videos,
                            it does not need to appear on a set-top box.
                        </Typography>
                    </Box>
                </Dialog>}
            </Box>
        </>
    );
}

const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(Game);
